var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageToPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
    fill: "#F7C5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.5441C10.5 12.0484 10.5 10.8006 11.2322 10.0253C11.9645 9.25 13.143 9.25 15.5 9.25H18C20.357 9.25 21.5355 9.25 22.2678 10.0253C23 10.8006 23 12.0484 23 14.5441V18.9559C23 21.4516 23 22.6994 22.2678 23.4747C21.5355 24.25 20.357 24.25 18 24.25H15.5C13.143 24.25 11.9645 24.25 11.2322 23.4747C10.5 22.6994 10.5 21.4516 10.5 18.9559V14.5441Z",
    stroke: "#323232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13.9163C20.5 13.5922 20.2035 13.2939 19.7061 13.0569C19.2656 12.8471 18.8125 13.2473 18.8125 13.7704V15.0828M20.5 13.9163V19.1034C20.5 19.8747 18.8211 20.5 16.75 20.5C14.6789 20.5 13 19.8747 13 19.1034V13.9163M20.5 13.9163C20.5 14.4038 19.8292 14.833 18.8125 15.0828M13 13.9163C13 13.5922 13.2965 13.2939 13.7939 13.0569C14.2344 12.8471 14.6875 13.2473 14.6875 13.7704V15.0828M13 13.9163C13 14.4038 13.6708 14.833 14.6875 15.0828M14.6875 15.0828C15.2792 15.2282 15.9881 15.3129 16.75 15.3129C17.5119 15.3129 18.2208 15.2282 18.8125 15.0828",
    stroke: "#323232",
    strokeWidth: 0.8125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 16.75C19.25 17.0952 18.9702 17.375 18.625 17.375C18.2798 17.375 18 17.0952 18 16.75C18 16.4048 18.2798 16.125 18.625 16.125C18.9702 16.125 19.25 16.4048 19.25 16.75Z",
    stroke: "#323232",
    strokeWidth: 0.8125
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 19.6857L19.1891 18.8093C18.8873 18.5267 18.4379 18.4985 18.1057 18.7415L18.0191 18.8048C17.7883 18.9736 17.4742 18.9453 17.2747 18.7377L16.0293 17.4418C15.7807 17.1831 15.382 17.1693 15.1174 17.4102L14.6089 17.8732L13.1875 19.32",
    stroke: "#323232",
    strokeWidth: 0.8125,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.15 22.9985C9.82452 22.9985 8.5 21.5579 8.5 19.9985V13.5C8.5 9.9506 8.56274 9.10266 9.5 8C10.4373 6.89734 12.133 6.99853 15.15 6.99853H18.5C19.8255 6.99853 20.5 7.93914 20.5 9.49853",
    stroke: "#323232"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageToPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image-to-pdf.851bc5c5c555149b4574a9799cd234f9.svg";